module.exports = __webpack_public_path__ + "static/img/867_phase_function_Paper_Points.133f005.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/867_phase_function_Paper_Points.png
// module id = xBuH
// module chunks = 0